import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import NotificationDropdown from '../notifications/NotificationDropdown';

const UserHeader = () => {
  const { profile } = useAuth();

  return (
    <header className="bg-white border-b border-gray-200 h-16 flex items-center justify-between px-6 sticky top-0 z-30">
      <h1 className="text-lg font-semibold text-dark-900">
        Olá, {profile?.full_name?.split(' ')[0]}
      </h1>
      
      <div className="flex items-center space-x-4">
        <NotificationDropdown />
        
        <div className="w-8 h-8 bg-primary-100 rounded-full flex items-center justify-center text-primary-700 font-bold text-sm">
          {profile?.full_name?.charAt(0) || 'U'}
        </div>
      </div>
    </header>
  );
};

export default UserHeader;